import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';

@Component({
  selector: 'app-permission-level-input',
  templateUrl: './permission-level-input.component.html',
  styleUrls: ['./permission-level-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: PermissionLevelInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: PermissionLevelInputComponent,
    },
  ],
})
export class PermissionLevelInputComponent {
  @Input()
  title = "Select Permission Level...";

  @Input()
  isDisabled = false;


  @Input()
  levels = [
    {
      name: 'None',
      value: "0",
    },
        {
      name: 'Read Only Permission',
      value: "1",
    },
    {
      name: 'Read & Create Permission',
      value: "2",
    },
    {
      name: 'Read, Create & Modify Permission',
      value: "3",
    },
  ];

  public value?: string;
  public localValue?: CustomSelectOption;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.levels.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val: CustomSelectOption) {
    this.value = val.value.toString();
    this.onChange(this.value);
    this.writeValue(this.value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
